import React, { useState, useEffect, useContext } from "react";

import { simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getFlujoCajaSemanalAsync } from "../../../api/Dashboard";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { chartTextColor, chartGridColor } from "../../../theme";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const money = (value) =>
  new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" }).format(value);

const moneyShort = (value) =>
  new Intl.NumberFormat("es-NI", {
    style: "currency",
    currency: "NIO",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);

// El backend devuelve siempre los 7 dias de lunes a domingo, asi que la
// etiqueta se saca de la fecha sin reordenar nada del lado del cliente.
const nombreDia = (fecha) =>
  ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"][
    new Date(fecha).getDay()
  ];

const FlujoCaja = ({ selectedSucursal }) => {
  const [datos, setDatos] = useState([]);

  const { setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getFlujoCajaSemanalAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setDatos(result.data.result || []);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSucursal]);

  const tick = chartTextColor(isDarkMode);
  const grid = chartGridColor(isDarkMode);

  const dataSet = {
    labels: datos.map((item) => nombreDia(item.fecha)),
    datasets: [
      {
        label: "Colocación",
        data: datos.map((item) => item.colocacion),
        backgroundColor: "rgba(18,163,90,.75)",
        borderColor: "#12a35a",
        borderWidth: 1,
        borderRadius: 6,
      },
      {
        label: "Recuperación",
        data: datos.map((item) => item.recuperacion),
        backgroundColor: "rgba(16,163,163,.75)",
        borderColor: "#10a3a3",
        borderWidth: 1,
        borderRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
        labels: { color: tick, boxWidth: 12, padding: 14, usePointStyle: true },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${money(context.parsed.y)}`,
        },
      },
    },
    scales: {
      x: {
        ticks: { color: tick },
        grid: { display: false },
      },
      y: {
        ticks: { color: tick, callback: (value) => moneyShort(value) },
        grid: { color: grid },
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ height: "100%" }}>
      <Bar data={dataSet} options={options} />
    </div>
  );
};

export default FlujoCaja;
